// Базовый URL API. В env может лежать абсолютный адрес ('https://api.setsushi.ru')
// или относительный путь ('/api'): тогда запросы идут на тот же домен, с которого
// открыта CRM, а nginx проксирует /api/ на бэкенд. Относительный путь достраивается
// до абсолютного здесь, потому что axios 0.21 склеивает относительный baseURL
// с относительным url запроса: '/api/crm' + '/api/crm/sounds' = '/api/crm/api/crm/sounds'
const raw = (process.env.VUE_APP_API_BASE_URL || 'https://api.setsushi.ru').replace(/\/$/, '')

export const API_BASE_URL = raw.startsWith('/') ? `${window.location.origin}${raw}` : raw
